// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".article-featured-media__media[data-v-4fc08678],.article-featured-media__wrapper[data-v-4fc08678]{border-radius:6px;overflow:hidden}", ""]);
// Exports
module.exports = exports;
